import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, X } from "lucide-react";

const extractYoutubeId = (input) => {
  const trimmed = input.trim();
  const match = trimmed.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return match ? match[1] : trimmed;
};

export const YoutubeVideosField = ({ videos, onChange, testId }) => {
  const [draft, setDraft] = useState("");

  const add = () => {
    if (!draft.trim()) return;
    onChange([...videos, extractYoutubeId(draft)]);
    setDraft("");
  };
  const remove = (i) => onChange(videos.filter((_, idx) => idx !== i));

  return (
    <div data-testid={testId} className="space-y-3">
      {videos.map((v, i) => (
        <div key={i} data-testid={`${testId}-item-${i}`} className="flex items-center gap-3 border border-border p-2">
          <img src={`https://img.youtube.com/vi/${v}/default.jpg`} alt="" className="w-16 h-12 object-cover shrink-0" />
          <span className="text-sm text-muted-foreground flex-1 truncate">{v}</span>
          <button type="button" data-testid={`${testId}-remove-${i}`} onClick={() => remove(i)}><X className="h-4 w-4" /></button>
        </div>
      ))}
      <div className="flex gap-2">
        <Input placeholder="Paste YouTube URL or video ID" className="rounded-none flex-1" value={draft} onChange={(e) => setDraft(e.target.value)} data-testid={`${testId}-input`} />
        <Button type="button" variant="outline" className="rounded-none" onClick={add} data-testid={`${testId}-add-button`}><Plus className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
